import React from 'react';
import styles from "./technologies.module.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHtml5,
    faCss3,
    faJs,
    faJava,
    faReact,
    faNode,
    faPython,
    faAngular,
    faAws,
    faGitAlt,
} from '@fortawesome/free-brands-svg-icons';
import { 
    faDatabase,  // For SQL
    faServer,    // For NoSQL
    faCogs,      // Placeholder for CI/CD Pipelines
    faCloud,     // Placeholder for Firebase
    faCode,      // Placeholder for REST APIs
    faBox,       // Placeholder for Docker
    faMobileAlt, // Placeholder for Flutter
    faDotCircle, // Placeholder for .NET
    faCodeBranch // Placeholder for TypeScript
} from '@fortawesome/free-solid-svg-icons';

const techIcons = [
    { icon: faHtml5, name: "HTML5" },
    { icon: faCss3, name: "CSS3" },
    { icon: faJs, name: "JavaScript" },
    { icon: faReact, name: "ReactJS" },
    { icon: faAngular, name: "Angular" },
    { icon: faJava, name: "Java" },
    { icon: faNode, name: "Node.js" },
    { icon: faPython, name: "Python" },
    { icon: faAws, name: "AWS" },
    { icon: faGitAlt, name: "Git" },
    { icon: faDatabase, name: "SQL" },
    { icon: faServer, name: "NoSQL" },
    { icon: faDotCircle, name: ".NET" },
    { icon: faMobileAlt, name: "Flutter" },
    { icon: faCodeBranch, name: "TypeScript" },
    { icon: faCloud, name: "Firebase" },
    { icon: faBox, name: "Docker" },
    { icon: faCogs, name: "CI/CD Pipelines" },
    { icon: faCode, name: "REST APIs" },
];

const Technologies = () => {
  return (
    <section className={`p-5 md:p-16 lg:p-20 ` + styles.technologies}>
        {techIcons.map((item, index) => (
            <div className={styles.technologies_icon} key={index}>
                <FontAwesomeIcon icon={item.icon} />
                <p>{item.name}</p>
            </div>
        ))}
    </section>
  );
};

export default Technologies;
